import { MACHINE_SERVICE_TYPE_NAMES, MACHINE_SERVICE_TYPES } from '../../constants';

// Not just the two constants - infers 'Restock-only' if it's restock & repair, but with no tickets.
export const getServiceTypeName = (item, ticketCount) => {
	// Repair-only - no restock
	if (item.machineServiceType === MACHINE_SERVICE_TYPES.REPAIR) {
		return MACHINE_SERVICE_TYPE_NAMES[item.machineServiceType];
	}
	// Restock & repair
	if (ticketCount) {
		return MACHINE_SERVICE_TYPE_NAMES[1];
	}
	// Restock only - no repairs

	return 'Restock';
};
